// extracted by mini-css-extract-plugin
export default {"row":"iATmk","column":"JHgTp","margin":"NH4hd","iframe":"qx3hz","loader":"wuCdY"};